import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { memoizedRefreshToken, removeUserData } from "./refreshToken";
import { isJwtExpired } from "jwt-check-expiration";

const AuthVerify = (props) => {
  let location = useLocation();

  useEffect(() => {
    const data = JSON.parse(localStorage.getItem("data"));
    if (data) {
      if (data?.RefreshToken) {
        //? check RefreshToken
        if (isJwtExpired(data?.RefreshToken)) {
          removeUserData();
        }
      }

      const checkJwt = async () => {
        if (isJwtExpired(data.Jwt)) {
          if (!data?.RefreshToken) {
            removeUserData();
          } else {
            await memoizedRefreshToken();
          }
        }
      };

      checkJwt();
    }
  }, [location, props]);

  return;
};

export default AuthVerify;
